module.exports = __webpack_public_path__ + "img/logo_5.872878dd.png";